import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AdminApiClient } from '@guiker/task-shared'

export const useAdminApiClient = useAuthenticatedApiClient(AdminApiClient)
